exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".splashText{\r\n\tfont-size: 80px\r\n}\r\n.orangehead{\r\n\tcolor: rgb(255,63,0);\r\n}\r\n.splashpanel{\r\n\tbackground-color: rgba(240,240,240, .9);\r\n\tmargin-top:10px;\r\n\tpadding:15px;\r\n\theight: 80vh;\r\n}\r\n.cont{\r\n\tpadding-top:10px;\r\n}\r\n.invalid{\r\n\tborder-left: 5px solid #a94442;\r\n}\r\n.errorText{\r\n\tfont-size: 16px;\r\n\tcolor: #a94442;\r\n}\r\n.submitButton{\r\n\tborder-color: rgb(220,30,0);\r\n\tbackground-color: rgb(255,63,0);\r\n}\r\n.submitButton:active{\r\n\tborder-color: rgb(180,15,0);\r\n\tbackground-color: rgb(220,30,0);\r\n}\r\n.submitButton:disabled{\r\n\tborder-color: rgb(180,15,0);\r\n\tbackground-color: rgb(255,90,45);\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Joey/Desktop/testdeploy/mk2/FindMeHireMe/src/app/splash/splash.component.css
// module id = ../../../../../src/app/splash/splash.component.css
// module chunks = main